"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserJoinedRoomEvent = void 0;
const validation_1 = require("../../validation");
const base_1 = require("./base");
var UserJoinedRoomEvent;
(function (UserJoinedRoomEvent) {
    UserJoinedRoomEvent.schema = {
        type: 'object',
        properties: {
            type: { type: 'string', const: base_1.Events.Type.COMMS },
            subType: { type: 'string', const: base_1.Events.SubType.Comms.USER_JOINED_ROOM },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 0 },
            metadata: {
                type: 'object',
                properties: {
                    parcel: { type: 'string' },
                    sceneId: { type: 'string' },
                    userAddress: { type: 'string' },
                    realmName: { type: 'string' },
                    isWorld: { type: 'boolean' }
                },
                required: ['parcel', 'sceneId', 'userAddress', 'realmName', 'isWorld']
            }
        },
        required: ['type', 'subType', 'key', 'timestamp', 'metadata']
    };
    UserJoinedRoomEvent.validate = (0, validation_1.generateLazyValidator)(UserJoinedRoomEvent.schema);
})(UserJoinedRoomEvent = exports.UserJoinedRoomEvent || (exports.UserJoinedRoomEvent = {}));
//# sourceMappingURL=comms.js.map